import { render } from "./BestStores.vue?vue&type=template&id=454b944e&scoped=true&ts=true"
import script from "./BestStores.vue?vue&type=script&lang=ts"
export * from "./BestStores.vue?vue&type=script&lang=ts"

import "./BestStores.vue?vue&type=style&index=0&id=454b944e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454b944e"]])

export default __exports__